import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getRequestId = (state) => resolveProp('identity.idRequestId', state);

export default createSelector(getRequestId, (idRequestId) => ({
    requestId: idRequestId,
}));
